export default {
  error_occurred: "Une erreur est survenue. Réessayez dans un instant.",
  login: "Se connecter",
  sign_up: "Créer un compte",
  register: "Inscription",
  enter_tenant_name: "Choisissez l’entreprise associée à votre compte Calendesk.",
  no_account_question: "Vous n’avez pas encore de compte ?",
  do_you_already_have_an_account: "Vous avez déjà un compte ou vous souhaitez vous connecter au compte de votre employeur ?",
  login_title: "Connectez-vous au panneau Calendesk",
  login_tenant: "Nom de votre entreprise",
  company_field_placeholder: "p. ex. Hair&More",
  next: "Suivant",
  register_subtitle: "Créez un nouvel espace de travail pour votre entreprise sur Calendesk",
  register_confirm_title: "Confirmez votre adresse e-mail",
  register_confirm_subtitle: "Nous avons envoyé un e-mail avec un lien d’activation à l’adresse indiquée lors de l’inscription.",
  register_confirm_text: "Activez votre compte pour accéder à Calendesk.",
  register_data_incorrect: "Cette adresse e-mail est déjà enregistrée dans le système Calendesk. Si vous avez oublié votre mot de passe, utilisez l’option de récupération.",
  resend_activate_email: "Renvoyer le lien d’activation",
  login_email: "Votre adresse e-mail",
  password: "Mot de passe",
  email_or_password_incorrect: "L’adresse e-mail ou le mot de passe est incorrect. Si vous avez oublié votre mot de passe, utilisez l’option de récupération.",
  please_activate_account: "Activez votre compte. Nous avons envoyé un lien d’activation à votre adresse e-mail.",
  activate_account_error_message: "Le lien est invalide ou a expiré.",
  forgotten_password: "Mot de passe oublié ?",
  forgotten_password_title: "Tout le monde oublie parfois son mot de passe.",
  forgotten_password_text: "Saisissez l’adresse e-mail à laquelle nous devons envoyer les instructions pour changer votre mot de passe.",
  forgotten_password_button: "Envoyer un lien pour changer le mot de passe",
  forgotten_password_success_title: "Vérifiez votre boîte de réception",
  forgotten_password_success_text: "Si cette adresse e-mail existe dans notre système, nous venons de vous envoyer un message avec les instructions pour changer votre mot de passe.",
  reset_password: "Définir un nouveau mot de passe",
  reset_password_title: "Définir un nouveau mot de passe",
  reset_password_text: "Saisissez votre nouveau mot de passe ci-dessous.",
  reset_password_text_hint: "Le mot de passe doit contenir au moins 8 caractères, dont une majuscule, un chiffre et un caractère spécial.",
  reset_password_button: "Enregistrer le nouveau mot de passe",
  reset_password_fail_text: "Le mot de passe n’a pas été modifié. Le lien a probablement expiré.",
  reset_password_success_title: "Votre mot de passe a été modifié.",
  reset_password_sent_email: "Un lien pour définir un mot de passe a été envoyé à l’adresse e-mail de l’utilisateur.",
  reset_password_success_text: "Vous pouvez vous connecter avec votre nouveau mot de passe.",
  reset_password_success_button: "OK",
  profile: "Profil",
  number_of_bookings: "Nombre de réservations",
  number_of_new_users: "Nombre de nouveaux clients",
  number_of_newsletter_members: "Nombre d’inscriptions à la newsletter",
  monthly_divided: "Répartition par mois",
  area_code: "Indicatif",
  other: "Autres",
  or: "ou",
  short_month_1: "JANV",
  short_month_2: "FÉVR",
  short_month_3: "MARS",
  short_month_4: "AVR",
  short_month_5: "MAI",
  short_month_6: "JUIN",
  short_month_7: "JUIL",
  short_month_8: "AOÛT",
  short_month_9: "SEPT",
  short_month_10: "OCT",
  short_month_11: "NOV",
  short_month_12: "DÉC",
  section_admin_panel: "Panneau",
  section_admin_panel_clients: "Panneau / Clients",
  section_admin_panel_newsletters: "Panneau / Clients / Newsletter",
  section_admin_panel_customer_notifications: "Panneau / Clients / Notifications",
  section_admin_panel_profile: "Panneau / Profil",
  section_admin_panel_employees: "Panneau / Employés",
  section_admin_panel_sales: "Panneau / Ventes",
  section_admin_panel_settings: "Panneau / Paramètres",
  section_admin_panel_service: "Panneau / Services",
  section_admin_panel_plugins: "Panneau / Extensions",
  section_admin_panel_payments: "Panneau / Factures et paiements",
  section_admin_panel_offer: "Panneau / Offre",
  section_admin_panel_tools: "Panneau / Outils",
  section_admin_panel_notifications: "Panneau / Notifications",
  simple_store: "Produits",
  section_admin_subscriptions_list: "Panneau / Abonnements",
  last_update: "Dernière mise à jour",
  add_client: "Ajouter un client",
  add_newsletter_record: "Ajouter une adresse e-mail",
  upload_photo: "Ajouter une photo",
  upload_photo_error_message: "La photo n’a pas pu être ajoutée. La taille maximale est de 10 Mo.",
  upload_photos_error_message: "Certaines photos n’ont peut-être pas été ajoutées. La taille maximale est de 10 Mo.",
  get_company_data: "Télécharger les données",
  get_company_data_failed: "Les données n’ont pas pu être téléchargées.",
  company_name: "Nom de l’entreprise",
  street_and_number: "Rue et numéro",
  postcode: "Code postal",
  city: "Ville",
  country: "Pays",
  send_email_with_password_change: "Envoyer un e-mail avec un lien pour définir le mot de passe ?",
  client_data: "Données du client",
  company_business_activity: "Données de facturation",
  remove_image: "Supprimer la photo",
  no_way_to_undo_action: "Cette action est irréversible.",
  remove_image_warning: "Voulez-vous vraiment supprimer la photo de l’utilisateur ?",
  add_booking: "Ajouter une réservation",
  add_unavailable_booking_slot: "Ajouter une date bloquée",
  add_tag: "Ajouter une étiquette",
  duplicate: "Dupliquer",
  add_to_group: "Ajouter à un groupe",
  cancel_booking: "Annuler la réservation",
  delete_booking: "Supprimer la réservation",
  delete_booking_failed: "La réservation sélectionnée n’a pas pu être supprimée",
  cancel_booking_failed: "La réservation sélectionnée n’a pas pu être annulée",
  selected_n_positions: "@{amount} élément sélectionné|@{amount} éléments sélectionnés",
  selected_all_n_records: "Tout sélectionné (@{amount})",
  select_all_n_records: "Tout sélectionner (@{amount})",
  clear_selection: "Annuler la sélection",
  bulk_operation_started: "Opération lancée. Cela peut prendre un moment.",
  bulk_operation_completed: "Opération terminée. Traités : @{processed}, échecs : @{failed}",
  bulk_operation_failed: "L’opération a échoué",
  bulk_operation_warning_count: "Concerne @{amount} enregistrements.",
  actions: "Actions",
  remove_multiple_users: "Supprimer les utilisateurs",
  remove_multiple_employees: "Supprimer les employés",
  remove_employee: "Supprimer l’employé",
  lock_multiple_users: "Bloquer les utilisateurs",
  unlock_multiple_users: "Débloquer les utilisateurs",
  lock_multiple_employees: "Bloquer les employés",
  unlock_multiple_employees: "Débloquer les employés",
  lock_employee: "Bloquer l’employé",
  unlock_employee: "Débloquer l’employé",
  user_remove_failed_bookings: "Cet utilisateur a des visites planifiées ou des abonnements actifs. Annulez-les avant de supprimer l’utilisateur.",
  employee_remove_failed_bookings_or_services: "Cet employé a des visites planifiées ou a déjà été supprimé. Annulez ou réattribuez ses visites avant de le supprimer.",
  operation_failed: "Une erreur est survenue lors de l’enregistrement des modifications. Réessayez.",
  accounts_update_succeeded: "Les comptes utilisateurs sélectionnés ont été mis à jour",
  accounts_update_failed: "Les comptes sélectionnés n’ont pas pu être mis à jour",
  remove_account_warning: "Voulez-vous vraiment supprimer le compte de l’utilisateur ?",
  remove_accounts_warning: "Voulez-vous vraiment supprimer les comptes utilisateurs sélectionnés ?",
  add_group: "Ajouter un groupe",
  sort_by: "Trier",
  basic_data: "Informations de base",
  public_data: "Renseignez des informations supplémentaires sur l’employé",
  remove_category: "Supprimer la catégorie",
  remove_category_warning: "Voulez-vous vraiment supprimer la catégorie ?",
  services_in_category: "Services dans la catégorie",
  services_already_assigned_in_category: "Des services sont attribués à cette catégorie. Attribuez-les à une autre catégorie pour continuer.",
  assign_service_to_category: "Attribuer un service à une catégorie",
  current_category: "Catégorie actuelle",
  services_assign_failed: "Une erreur est survenue lors de l’attribution des services sélectionnés à la catégorie",
  assign_n_services_to_category: "Attribuer @{n} services à une catégorie :",
  category_order_info: "L’ordre choisi pour les catégories et les services sera repris sur le site web visible par vos clients.",
  lock_account: "Bloquer le compte",
  remove_account: "Supprimer le compte",
  fetch_data_failed: "Une erreur est survenue lors du téléchargement des données",
  edit_service: "Modifier le service",
  remove_service: "Supprimer le service",
  variants: "Options",
  booking_settings: "Paramètres de réservation",
  booking_time_before: "Réservation du service au plus tard",
  cancel_time_before: "Annulation du service au plus tard",
  change_time_before: "Report du service au plus tard",
  before_visit: "avant la visite",
  slots_every_checkbox_text: "Proposer aux clients de réserver toutes les",
  break_time_before_checkbox_text: "Temps de pause supplémentaire avant la réservation créée",
  break_time_after_checkbox_text: "Temps de pause supplémentaire après la réservation créée",
  resources_info: "Sélectionnez les ressources limitées nécessaires pendant le service. Les clients ne pourront pas réserver de visite en ligne si les ressources sont épuisées par d’autres visites.",
  quantity: "Quantité",
  quantity_pcs: "Quantité (pcs)",
  value_is_too_high: "La valeur saisie est trop élevée. Valeur maximale : @{number}.",
  value_is_too_low: "La valeur saisie est trop faible. Valeur minimale : @{number}.",
  resource_name: "Nom de la ressource",
  add_variant: "Ajouter une option de service",
  service_active: "Service actif dans le calendrier des clients",
  category_active_short: "Active",
  category_inactive_short: "Inactive",
  variant_name: "Nom de l’option",
  service_blocked: "Service bloqué",
  all_employees: "Tous les employés",
  price_in_currency: "Prix en @{currency}",
  no_employees_found: "Aucun employé ajouté. Vous pouvez en créer un et l’attribuer à ce service. Vos clients pourront choisir parmi les employés attribués à ce service.",
  add_employee_fail: "Un problème est survenu lors de l’ajout de l’employé. Réessayez.",
  select_employee_error: "Sélectionnez au moins un employé",
  service_update_failed: "La mise à jour du service a échoué. Réessayez.",
  service_creation_failed: "La création du service a échoué. Réessayez.",
  remove_service_warning: "Voulez-vous vraiment supprimer le service ?",
  remove_service_failed: "La suppression du service a échoué. Réessayez.",
  move: "Déplacer",
  tag_visits: "Visites avec étiquette",
  services_with_resource: "Services avec une ressource",
  resource: "Ressource",
  users_in_group: "Clients dans le groupe",
  remove_tag_warning: "Voulez-vous vraiment supprimer l’étiquette « @{tag} » ?",
  remove_tag: "Supprimer l’étiquette",
  edit_tag: "Modifier l’étiquette",
  remove_resource_warning: "Voulez-vous vraiment supprimer la ressource « @{resource} » ?",
  remove_resource: "Supprimer la ressource",
  edit_resource: "Modifier la ressource",
  remove_group_warning: "Voulez-vous vraiment supprimer le groupe « @{group} » ?",
  remove_group: "Supprimer le groupe",
  edit_group: "Modifier le groupe",
  tag_info: "Les étiquettes décrivent les caractéristiques des réservations de vos clients. Vous pouvez attribuer des étiquettes à vos réservations, puis les retrouver facilement à l’aide des filtres.",
  resource_info: "Les ressources représentent tout ce dont vous avez besoin pour réaliser vos services, par exemple une salle de réunion, une chaise ou une table de massage.",
  resource_info_2: "En attribuant des ressources à vos services, vous évitez de manquer d’équipement au moment de servir vos clients. Vous pouvez le faire lors de la création ou de la modification d’un service.",
  group_info: "Les groupes facilitent la gestion des clients. Chaque client peut appartenir à plusieurs groupes. Comme pour les étiquettes, vous pouvez ensuite filtrer vos clients par groupe.",
  email_notifications: "Notifications par e-mail",
  sms_notifications: "Notifications par SMS",
  buy_more: "Acheter",
  notifications_count: "Nombre de notifications",
  pay: "Payer",
  notification_first_label: "Il reste",
  notification_second_label_email: "notifications par e-mail",
  notification_second_label_sms: "Notifications par SMS",
  notifications_sms_email: "Notifications par SMS et par e-mail",
  notifications_reminder_first: "Les notifications peuvent être envoyées dès la création, la modification ou la suppression d’une réservation.",
  notifications_reminder_second: "Vous pouvez aussi définir l’heure d’envoi des rappels et choisir qui notifier et comment.",
  notification: "Notification",
  notify_tenant: "Employé",
  notify_client: "Client",
  notification_save_success: "Les notifications ont été mises à jour.",
  invoice_data: "Données de facturation",
  service_categories: "Catégories de services",
  application: "Application",
  email: "E-mail",
  currency: "PLN",
  category: "Catégorie",
  categories: "Catégories",
  service: "Service",
  service_list: "Liste des services",
  services: "Services",
  employee: "Employé",
  employees: "Employés",
  employees_list: "Liste des employés",
  plugins: "Extensions",
  packages: "Vos packs",
  plugins_mobile_drafts: "Application mobile",
  plugins_mobile_editor: "Éditeur d’application mobile",
  plugins_payments_tpay: "Paiements TPay",
  plugins_payments_stripe: "Paiements Stripe",
  settings_platform: "Plateforme",
  notifications: "Notifications",
  profile_company: "Votre entreprise",
  profile_account: "Votre profil",
  payments: "Factures et paiements",
  settings: "Paramètres",
  duration: "Durée",
  from: "De",
  to: "À",
  filter: "Filtrer",
  close: "Fermer",
  today: "Aujourd’hui",
  tomorrow: "Demain",
  this_week: "Cette semaine",
  this_month: "Ce mois-ci",
  this_year: "Cette année",
  yesterday: "Hier",
  last_week: "La semaine dernière",
  last_month: "Le mois dernier",
  last_year: "L’année dernière",
  clear: "Effacer",
  service_name: "Nom du service",
  category_name: "Nom de la catégorie",
  price: "Prix",
  name: "Prénom",
  surname: "Nom",
  from_cannot_be_greater_than_to: "L’heure « de » ne peut pas être postérieure à l’heure « à »",
  name_and_surname: "Nom et prénom",
  phone: "Téléphone",
  field_is_required: "Ce champ est obligatoire.",
  value_is_no_url: "La valeur saisie n’est pas une URL valide.",
  value_is_no_url_to_facebook: "La valeur saisie n’est pas une URL de profil Facebook valide.",
  value_is_no_url_to_twitter: "La valeur saisie n’est pas une URL de profil X valide.",
  value_is_no_url_to_instagram: "La valeur saisie n’est pas une URL de profil Instagram valide.",
  value_is_no_url_to_youtube: "La valeur saisie n’est pas une URL de profil YouTube valide.",
  value_is_no_domain: "La valeur saisie n’est pas un nom de domaine.",
  min_n_characters: "Le nombre minimal de caractères est @{min}.",
  max_n_characters: "Le nombre maximal de caractères est @{max}.",
  email_is_incorrect: "L’adresse e-mail est incorrecte.",
  invalid_nip: "Le numéro fiscal n’est pas un numéro NIP polonais valide.",
  page_not_found: "La page que vous recherchez est introuvable.",
  go_back_to_main_page: "Revenez à la page d’accueil et réessayez.",
  logout: "Se déconnecter",
  status: "Statut",
  status_approved: "Acceptée",
  status_waiting: "En attente",
  status_payment: "En attente de paiement",
  status_cancelled: "Annulée",
  status_done: "Terminée",
  status_failed: "Échec",
  gov_status_ok: "Acceptée",
  gov_status_rejected: "Rejetée",
  gov_status_error: "Erreur",
  gov_status_not_sent: "Non envoyée",
  gov_status_not_applicable: "Non applicable",
  gov_status_sent: "Envoyée (en attente)",
  gov_status_demo_processing: "Démo (en cours de traitement)",
  date: "Date",
  cancel: "Annuler",
  yes: "Oui",
  no: "Non",
  date_from: "Date de début",
  date_to: "Date de fin",
  nothing_found_here: "Aucun résultat",
  nothing_here: "Aucun",
  save: "Enregistrer",
  details: "Détails",
  open_link: "Ouvrir le lien",
  add_image: "Ajouter une photo",
  change: "Changer",
  remove: "Supprimer",
  email_is_taken: "Un compte avec cette adresse e-mail existe déjà.",
  dashboard: "Tableau de bord",
  users: "Clients",
  users_list: "Liste des clients",
  calendar: "Calendrier",
  add: "Ajouter",
  resources: "Ressources",
  translations: "Traductions",
  web_editor: "Éditeur de site web",
  websites: "Sites web",
  mobile_app_title: "Application mobile",
  preview: "Aperçu",
  roles: "Fonction",
  role_admin: "Administrateur",
  role_manager: "Manager",
  role_employee: "Employé (de confiance)",
  role_employee_basic: "Employé (accès restreint)",
  permissions: "Autorisations",
  admin_access_question: "L’employé peut se connecter au panneau Calendesk",
  send_employees_app_link: "Envoyer le lien de l’application mobile à l’employé par e-mail",
  search: "Rechercher",
  add_user: "Ajouter un client",
  add_employee: "Ajouter un employé",
  add_category: "Ajouter une catégorie",
  edit_category: "Modifier la catégorie",
  add_service: "Ajouter un service",
  add_resource: "Ajouter une ressource",
  bookings_today: "Réservations d’aujourd’hui",
  bookings_tomorrow: "Réservations de demain",
  bookings_this_week: "Réservations de la semaine",
  newsletter: "Newsletter",
  month_1: "janvier",
  month_2: "février",
  month_3: "mars",
  month_4: "avril",
  month_5: "mai",
  month_6: "juin",
  month_7: "juillet",
  month_8: "août",
  month_9: "septembre",
  month_10: "octobre",
  month_11: "novembre",
  month_12: "décembre",
  monday: "lundi",
  tuesday: "mardi",
  wednesday: "mercredi",
  thursday: "jeudi",
  friday: "vendredi",
  saturday: "samedi",
  sunday: "dimanche",
  short_day_monday: "lun.",
  short_day_tuesday: "mar.",
  short_day_wednesday: "mer.",
  short_day_thursday: "jeu.",
  short_day_friday: "ven.",
  short_day_saturday: "sam.",
  short_day_sunday: "dim.",
  refresh: "Actualiser",
  select_date: "Sélectionner une date",
  edit: "Modifier",
  ok: "OK",
  client: "Client",
  clients: "Clients",
  tag: "Étiquette",
  added_tag: "L’étiquette a été ajoutée",
  added_group: "Le groupe a été ajouté",
  added_resource: "La ressource a été ajoutée",
  tags: "Étiquettes",
  phone_is_invalid: "Le numéro de téléphone est incorrect.",
  birthday: "Date de naissance",
  send_reset_password: "Envoyer un e-mail avec un lien pour définir le mot de passe ?",
  user_created_successfully: "Le client a été créé.",
  employee_created_successfully: "L’employé a été créé.",
  description: "Description",
  created_calendar_event_correctly: "L’entrée a été ajoutée au calendrier.",
  updated_calendar_event_correctly: "L’entrée du calendrier a été mise à jour.",
  updated_multiple_bookings_correctly: "Les réservations ont été mises à jour.",
  deleted_multiple_bookings_correctly: "Les réservations ont été supprimées.",
  deleted_multiple_unavailable_booking_slots_correctly: "Les dates bloquées ont été supprimées.",
  deleted_service_event_correctly: "Le service a été supprimé.",
  creating_calendar_event_failed: "L’ajout de l’entrée a échoué, veuillez réessayer.",
  deleting_service_event_failed: "La suppression a échoué. Vérifiez qu’aucune visite n’est prévue pour ce service, puis réessayez.",
  updating_calendar_event_failed: "La mise à jour de l’entrée a échoué, veuillez réessayer.",
  updating_bookings_failed: "La mise à jour de la réservation a échoué, veuillez réessayer.",
  deleting_bookings_failed: "La suppression de la réservation a échoué, veuillez réessayer.",
  block_spot: "Un événement sans lien avec la visite du client (dates bloquées pour les clients)",
  block: "Blocage",
  unavailable_spot: "Bloqué",
  id: "ID",
  per_page: "Éléments par page",
  groups: "Groupes",
  group: "Groupe",
  delete: "Supprimer",
  facebook: "Lien vers le profil Facebook",
  instagram: "Lien vers le profil Instagram",
  youtube: "Lien vers le profil YouTube",
  twitter: "Lien vers le profil X",
  active_accounts: "Comptes actifs",
  inactive_accounts: "Comptes inactifs",
  active_account: "Compte actif",
  inactive_account: "Compte inactif",
  visit: "Visite",
  loading: "Chargement…",
  created_at: "Créé le",
  canceled_at: "Annulé le",
  user: "Utilisateur",
  category_active: "Catégorie de services visible pour les clients",
  category_inactive: "Catégorie de services masquée pour les clients",
  email_verified_at: "Vérification de l’e-mail",
  email_unverified: "E-mail non vérifié",
  gender: "Genre",
  gender_male: "Homme",
  gender_female: "Femme",
  gender_other: "Autre",
  tax: "Numéro de TVA",
  tax_prefix: "Préfixe",
  block_account: "Bloquer le compte",
  unblock_account: "Débloquer le compte",
  generate_new_password_automatically: "Envoyer par e-mail un lien pour modifier le mot de passe.",
  unblock_account_question: "Voulez-vous vraiment débloquer ce compte ?",
  block_account_question: "Voulez-vous vraiment bloquer ce compte ?",
  delete_user: "Supprimer le compte",
  delete_users: "Supprimer les comptes",
  user_can_not_be_loaded: "Une erreur est survenue. Impossible de charger l’utilisateur.",
  user_bookings: "Réservations",
  user_newsletter: "Newsletter",
  title: "Titre",
  color: "Couleur",
  no_employee_selected_in_calendar: "Aucun employé sélectionné. Choisissez-les dans la liste ci-dessus pour afficher le calendrier.",
  client_policy_confirmation_text: "Le client confirme avoir lu les conditions générales et la politique de confidentialité.",
  listWeek: "Planning du jour",
  resourceTimeGridDay: "Jour",
  timeGridWeek: "Semaine",
  dayGridMonth: "Mois",
  current_week: "Semaine en cours",
  current_month: "Mois en cours",
  date_day_from: "Du (jour)",
  date_hour_from: "De (heure)",
  date_day_to: "Au (jour)",
  date_hour_to: "À (heure)",
  created_date_range: "Date de création",
  canceled_date_range: "Date d’annulation",
  event_date_range: "Date de l’événement",
  payment_date_range: "Date de paiement",
  you_can_add_note_here: "Vous pouvez ajouter ici une note privée",
  account_activation_resend_link_succeeded: "Le lien d’activation a été renvoyé",
  account_activation_resend_link_failed: "Une erreur est survenue lors de la génération du lien, veuillez réessayer",
  calendar_settings: "Paramètres du calendrier",
  minimal_length_of_calendar_event: "Durée minimale d’un événement dans le calendrier",
  hour_divider_interval: "Repères horaires visibles toutes les",
  calendar_time_boundaries: "Plage horaire du calendrier",
  all_bookings: "Toutes les réservations",
  bookings: "Réservations",
  more: "plus",
  visit_datetime: "Date et heure de la réservation",
  client_names: "Prénom et nom du client",
  waiting: "En attente",
  payment: "En attente de paiement",
  approved: "Acceptée",
  cancelled: "Annulée",
  done: "Terminée",
  delete_succeeded: "L’élément a été supprimé.",
  delete_failed: "Une erreur est survenue lors de la suppression",
  confirmation_modal_header: "Confirmation requise",
  confirmation_modal_warning: "Voulez-vous vraiment continuer ?",
  change_status: "Changer le statut",
  remove_n: "Supprimer (@{n})",
  remove_event: "Supprimer l’événement",
  editor_tool_global_settings_title: "Paramètres globaux",
  editor_tool_global_settings_subtitle: "Couleur et logo",
  calendesk_file_input_first: "Déposez les fichiers ici ou",
  calendesk_file_input_second: "choisissez-les sur votre disque",
  calendesk_file_input_third: "pour les ajouter",
  assets: "Fichiers",
  domain_configuration_title: "Configuration du domaine",
  domain_configuration_subtitle: "Choisissez le domaine sous lequel votre site web sera accessible",
  domain_configuration_calendesk_domain: "Saisissez le nom du sous-domaine (alias) sous lequel votre site sera accessible, par exemple « votreentreprise.calendesk.com ».",
  domain_configuration_calendesk_domain_2: "Saisissez le nom du sous-domaine (alias) sous lequel votre site sera accessible, par exemple « votreentreprise.calendesk.net ».",
  domain_configuration_own_domain_text: "Vous pouvez aussi ajouter votre propre domaine, par exemple « votreentreprise.fr ».",
  domain_configuration_own_domain_add_button: "Ajouter votre propre domaine",
  domain_configuration_own_domain_edit_button: "Modifier votre propre domaine",
  domain_configuration_footer: "Votre site sera accessible à l’adresse @{domain}",
  domain_configuration_form_alias: "Sous-domaine (alias), par exemple le nom de votre entreprise",
  domain_configuration_form_domain: "Domaine",
  add_domain_title: "Ajout de votre propre domaine",
  add_domain_verification_error: "Le domaine est en cours de vérification. Si tout a été configuré correctement, patientez 15 minutes, puis réessayez.",
  add_domain_verification_success: "Le domaine fonctionne correctement",
  add_domain_first_step_title: "Votre domaine",
  add_domain_first_step_subtitle: "Saisissez le nom de domaine que vous souhaitez associer à votre site web",
  add_domain_first_step_domain: "Votre domaine",
  add_domain_first_step_confirm: "Continuer",
  add_domain_second_step_title: "Panneau du fournisseur de domaine",
  add_domain_second_step_subtitle: "Connectez-vous au panneau de votre fournisseur de domaine, recherchez la section des paramètres DNS et ajoutez les deux nouveaux enregistrements indiqués à l’étape suivante.",
  add_domain_second_step_confirm: "Continuer",
  add_domain_third_step_title: "Ajoutez les nouveaux enregistrements",
  add_domain_third_step_subtitle: "Ajoutez les enregistrements de domaine comme indiqué ci-dessous. Chez certains fournisseurs de domaine, l’enregistrement CNAME peut se terminer par un point.",
  add_domain_third_step_subtitle_dot: "avec un point à la fin",
  add_domain_third_step_confirm: "Continuer",
  add_domain_third_step_dns_name: "Nom",
  add_domain_third_step_dns_type: "Type",
  add_domain_third_step_dns_url: "Adresse",
  add_domain_fourth_step_title: "Vérification du fonctionnement",
  add_domain_fourth_step_subtitle: "Une fois le domaine correctement configuré, vérifiez les modifications.",
  add_domain_fourth_step_confirm: "Vérifier le fonctionnement du domaine",
  web_global_logo: "Logo",
  web_global_primary_color: "Couleur principale",
  gallery_input_set_image: "Insérer",
  no_selected_images: "Aucune photo sélectionnée",
  home_about_element_gallery: "Photos de la galerie",
  new_website: "Nouveau site web",
  drafts_table_header_title: "Nom du modèle",
  drafts_table_header_last_updated: "Date de modification",
  published_text: "Publié",
  not_published_text: "Non publié",
  disabled: "Désactivé",
  publish: "Publier",
  drafts_category_1: "Beauté",
  drafts_category_2: "Fitness",
  drafts_create_website_button: "Créer un site web",
  tool_save_draft: "Enregistrer le brouillon",
  drafts_disable_confirm_dialog_title: "Désactiver le site web",
  drafts_disable_confirm_dialog_warning: "Voulez-vous vraiment désactiver le site web ?",
  drafts_disable_confirm_dialog_inportant_information: "Une fois désactivé, votre site web ne sera plus accessible en ligne.",
  drafts_remove_confirm_dialog_title: "Supprimer le brouillon",
  drafts_remove_confirm_dialog_warning: "Voulez-vous vraiment supprimer le brouillon ?",
  domain_dialog_title: "Adresse de votre site web",
  domain_dialog_button: "Configurer le domaine",
  domain_dialog_domain_text: "Votre site web sera affiché à l’adresse :",
  editor_domain_error_message: "Le domaine sélectionné n’est pas disponible",
  publish_dialog_button: "Revenir aux brouillons",
  files: "Fichiers",
  assets_no_data: "Aucune photo ajoutée",
  assets_dialog_use_selected_file: "Utiliser le fichier sélectionné",
  assets_dialog_use_selected_files: "Utiliser les fichiers sélectionnés",
  remove_asset: "Supprimer le fichier",
  remove_asset_warning: "Voulez-vous vraiment supprimer @{file} ?",
  change_name_asset_title: "Renommer le fichier « @{file} »",
  change_name_asset_new_name: "Nouveau nom de fichier",
  editor_image: "Éditeur d’images",
  editor_image_confirm_button: "Appliquer",
  editor_image_crop_any: "Libre",
  editor_image_crop_5_4: "5:4",
  editor_image_crop_7_5: "7:5",
  editor_image_crop_16_9: "16:9",
  editor_image_crop_3_2: "3:2",
  editor_image_crop_square: "Carré",
  editor_image_reset: "Réinitialiser",
  editor_image_rotate_left: "Pivoter de 90° vers la gauche",
  editor_image_rotate_right: "Pivoter de 90° vers la droite",
  editor_image_flip_x: "Retourner sur l’axe X",
  editor_image_flip_y: "Retourner sur l’axe Y",
  form_is_invalid: "Le formulaire contient des erreurs. Vérifiez les champs en surbrillance, puis réessayez.",
  no_integer: "Un chiffre est requis.",
  no_numeric_character: "Il manque un chiffre.",
  no_lowercase_character: "Une lettre minuscule est requise.",
  no_uppercase_character: "Il manque une lettre majuscule.",
  no_special_character: "Il manque un caractère spécial.",
  c_language_select_label: "Langue",
  c_currency_select_label: "Devise",
  c_time_zone_autocomplete_label: "Fuseau horaire",
  c_language_select_polish: "Polski",
  c_language_select_german: "Deutsch",
  c_language_select_english: "English",
  c_language_select_spanish: "Español",
  c_language_select_czech: "Čeština",
  c_language_select_french: "Français",
  c_language_select_hindi: "हिन्दी",
  c_language_select_dutch: "Nederlands",
  c_language_select_portuguese: "Português",
  c_language_select_russian: "Русский",
  c_language_select_slovak: "Slovenčina",
  c_language_select_ukrainian: "Українська",
  c_language_select_bulgarian: "Български",
  c_language_select_greek: "Ελληνικά",
  c_language_select_estonian: "Eesti",
  c_language_select_finnish: "Suomi",
  c_language_select_irish: "Gaeilge",
  c_language_select_croatian: "Hrvatski",
  c_language_select_hungarian: "Magyar",
  c_language_select_lithuanian: "Lietuvių",
  c_language_select_latvian: "Latviešu",
  c_language_select_maltese: "Malti",
  c_language_select_slovenian: "Slovenščina",
  c_language_select_albanian: "Shqip",
  c_language_select_swedish: "Svenska",
  c_currency_select_pln: "Zloty polonais (PLN)",
  c_currency_select_eur: "Euro (EUR)",
  c_currency_select_usd: "Dollar américain (USD)",
  c_currency_select_gbp: "Livre sterling (GBP)",
  c_currency_select_jpy: "Yen japonais (JPY)",
  c_currency_select_aud: "Dollar australien (AUD)",
  c_currency_select_cad: "Dollar canadien (CAD)",
  c_currency_select_chf: "Franc suisse (CHF)",
  c_currency_select_sek: "Couronne suédoise (SEK)",
  c_currency_select_nzd: "Dollar néo-zélandais (NZD)",
  c_currency_select_brl: "Real brésilien (BRL)",
  c_currency_select_bgn: "Lev bulgare (BGN)",
  c_currency_select_czk: "Couronne tchèque (CZK)",
  c_currency_select_dkk: "Couronne danoise (DKK)",
  c_currency_select_hkd: "Dollar de Hong Kong (HKD)",
  c_currency_select_huf: "Forint hongrois (HUF)",
  c_currency_select_ils: "Nouveau shekel israélien (ILS)",
  c_currency_select_myr: "Ringgit malaisien (MYR)",
  c_currency_select_mxn: "Peso mexicain (MXN)",
  c_currency_select_twd: "Nouveau dollar de Taïwan (TWD)",
  c_currency_select_nok: "Couronne norvégienne (NOK)",
  c_currency_select_php: "Peso philippin (PHP)",
  c_currency_select_ron: "Leu roumain (RON)",
  c_currency_select_rub: "Rouble russe (RUB)",
  c_currency_select_sgd: "Dollar de Singapour (SGD)",
  c_currency_select_thb: "Baht thaïlandais (THB)",
  c_currency_select_uah: "Hryvnia ukrainienne (UAH)",
  c_currency_select_inr: "Roupie indienne (INR)",
  c_currency_select_clp: "Peso chilien (CLP)",
  c_currency_select_zar: "Rand sud-africain (ZAR)",
  c_currency_select_bif: "Franc burundais (BIF)",
  c_currency_select_djf: "Franc djiboutien (DJF)",
  c_currency_select_gnf: "Franc guinéen (GNF)",
  c_currency_select_kmf: "Franc comorien (KMF)",
  c_currency_select_krw: "Won sud-coréen (KRW)",
  c_currency_select_mga: "Ariary malgache (MGA)",
  c_currency_select_pyg: "Guarani paraguayen (PYG)",
  c_currency_select_rwf: "Franc rwandais (RWF)",
  c_currency_select_ugx: "Shilling ougandais (UGX)",
  c_currency_select_vnd: "Dong vietnamien (VND)",
  c_currency_select_vuv: "Vatu du Vanuatu (VUV)",
  c_currency_select_xaf: "Franc CFA BEAC (XAF)",
  c_currency_select_xof: "Franc CFA BCEAO (XOF)",
  c_currency_select_xpf: "Franc CFP (XPF)",
  profile_company_name_label_input: "Nom de l’entreprise",
  profile_company_name_placeholder_input: "p. ex. Hair&More",
  profile_company_contact_header: "Coordonnées",
  profile_company_contact_address_label_autocomplete: "Adresse",
  profile_company_contact_email_label_input: "Adresse e-mail",
  profile_company_contact_country_autocomplete: "Pays",
  profile_company_work_hours_header: "Jours et heures de travail",
  profile_company_social_media_header: "Réseaux sociaux",
  profile_company_social_media_facebook_label_input: "Lien vers le profil Facebook",
  profile_company_social_media_twitter_label_input: "Lien vers le profil X",
  profile_company_social_media_instagram_label_input: "Lien vers le profil Instagram",
  profile_company_social_media_youtube_label_input: "Lien vers le profil YouTube",
  profile_company_regulations_header: "Conditions générales",
  profile_company_regulations_label_textarea: "Conditions générales",
  profile_company_privacy_policy_header: "Politique de confidentialité",
  profile_company_privacy_policy_label_textarea: "Politique de confidentialité",
  profile_company_contact_street_label_input: "Rue et numéro",
  profile_company_contact_zip_code_label_input: "Code postal",
  profile_company_contact_city_label_input: "Ville",
  plugins_store_all_plugins_tab: "Toutes les extensions",
  plugins_mobile_drafts_header_button: "Modifier l’application mobile",
  create_mobile_draft_dialog_title: "Choisissez un modèle",
  create_mobile_draft_dialog_name_label_input: "Nom du modèle",
  create_mobile_draft_dialog_name_label_input_placeholder: "p. ex. Mon application",
  create_mobile_draft_dialog_select_category: "Catégorie",
  create_mobile_draft_dialog_submit: "Enregistrer et continuer",
  plugins_mobile_drafts_new_application_button: "Nouvelle application mobile",
  plugins_mobile_drafts_disable_confirm_dialog_title: "Désactiver l’application mobile",
  plugins_mobile_drafts_disable_confirm_dialog_warning: "Voulez-vous vraiment désactiver l’application mobile ?",
  plugins_mobile_drafts_disable_confirm_dialog_important_information: "Une fois désactivée, votre application ne sera plus disponible en ligne.",
  plugins_mobile_drafts_remove_confirm_dialog_title: "Supprimer le brouillon",
  plugins_mobile_drafts_remove_confirm_dialog_warning: "Voulez-vous vraiment supprimer le brouillon ?",
  plugins_mobile_preview_information_title: "Aperçu des modifications sur votre téléphone",
  plugins_mobile_preview_information_paragraph_1: "Publiez le modèle. Téléchargez l’application Calendesk et saisissez le nom sur le premier écran",
  plugins_mobile_preview_information_paragraph_2: "comme identifiant de l’entreprise. Connectez-vous ensuite à votre compte utilisateur avec votre adresse e-mail et votre mot de passe.",
  plugins_mobile_preview_information_paragraph_3: "Une fois connecté, l’application s’actualisera automatiquement à chaque modification effectuée ici.",
  plugins_mobile_preview_text_button: "Envoyer le lien vers l’application",
  send_mobile_app_link_dialog_title: "Envoyer le lien vers l’application",
  send_mobile_app_link_dialog_email_tab_title: "E-mail",
  send_mobile_app_link_dialog_email_tab_input_label: "Adresse e-mail à laquelle envoyer le lien vers l’application",
  send_mobile_app_link_dialog_email_tab_submit_button: "Envoyer l’e-mail",
  send_mobile_app_link_dialog_sms_tab_title: "SMS",
  send_mobile_app_link_dialog_sms_tab_input_label: "Numéro de téléphone auquel envoyer le lien vers l’application",
  send_mobile_app_link_dialog_sms_tab_submit_button: "Envoyer le SMS",
  publish_mobile_draft_dialog_title: "L’application mobile est en cours de publication",
  publish_mobile_draft_dialog_subtitle: "Il peut s’écouler quelques minutes avant que l’application ne soit visible en ligne.",
  publish_mobile_draft_dialog_button: "Revenir aux brouillons",
  mobile_home_form_title: "Vue principale",
  mobile_home_form_logo_label: "Photo d’arrière-plan",
  mobile_home_form_logo_select_button: "Sélectionner",
  mobile_home_form_slogan_label: "En-tête",
  mobile_home_form_signup_button: "Bouton d’inscription",
  mobile_services_form_title: "Services",
  mobile_services_form_menu_services_label: "Onglet",
  mobile_services_form_services_title: "En-tête",
  mobile_services_form_services_input_label: "Recherche",
  mobile_services_form_services_search_empty_screen_subtitle_label: "Aucun résultat",
  mobile_services_form_services_types_title_label: "Options de service",
  mobile_services_form_cancel_booking_success_button_label: "Bouton « Autre »",
  mobile_services_form_logo_label: "Photo d’arrière-plan",
  mobile_services_form_logo_select_button: "Sélectionner",
  mobile_about_us_form_title: "À propos de nous",
  mobile_about_us_form_location_title: "En-tête du lieu",
  mobile_about_us_form_location_info: "Vous pouvez définir l’adresse dans le panneau principal Calendesk, dans Paramètres / Votre entreprise. Si vous supprimez l’adresse, elle sera aussi masquée dans l’application.",
  mobile_about_us_form_location_2_info: "Renseignez l’adresse dans le panneau principal Calendesk, dans Paramètres / Votre entreprise, pour afficher le lieu de votre entreprise dans cette section.",
  mobile_about_us_form_menu_about_us_label: "Onglet",
  mobile_about_us_form_about_us_about_us_title_label: "En-tête de la description",
  mobile_about_us_form_contact_info: "Vous pouvez définir le numéro de téléphone et les horaires d’ouverture dans le panneau Calendesk, dans Paramètres / Votre entreprise. Pour masquer les sections ci-dessus, supprimez leur contenu.",
  mobile_about_us_form_employee_info: "Les employés visibles dans cette section se configurent dans le panneau Calendesk, dans l’onglet Employés.",
  mobile_about_us_form_bookings_info: "Dans l’aperçu à droite, vous voyez des exemples de réservations.",
  mobile_about_us_form_about_us_employees_title_label: "En-tête des spécialistes",
  mobile_about_us_form_about_us_contact_title_label: "En-tête du contact",
  mobile_about_us_form_about_us_text_label: "Texte",
  mobile_about_us_form_logo_label: "Photo d’arrière-plan",
  mobile_about_us_form_logo_select_button: "Sélectionner",
  mobile_bookings_form_title: "Réservations",
  mobile_bookings_form_menu_bookings_label: "Onglet",
  mobile_bookings_form_menu_active_bookings_label: "Réservations actives",
  mobile_bookings_form_menu_previous_bookings_label: "Réservations passées",
  mobile_account_form_title: "Profil",
  mobile_account_form_menu_bookings_label: "Onglet",
  mobile_account_editor_info_message: "Sélectionnez ci-dessous la section que vous souhaitez modifier. Vous pouvez télécharger l’application mobile pour vos clients depuis @{google} ou @{apple} et voir le résultat dès sa publication.",
  mobile_account_editor_info_message_2: "Après avoir téléchargé l’application, saisissez le nom de votre entreprise (@{company}) sur le premier écran.",
  mobile_account_editor_home_image_message: "La taille conseillée de l’image principale est de 600x800 pixels.",
  mobile_account_editor_global_logo_image_message: "La taille conseillée du logo est de 600x300 pixels.",
  add_payment_method_dialog_subtitle: "Saisissez les données de la carte que vous utiliserez pour vos paiements Calendesk. Calendesk ne conserve pas les données de votre carte : elles sont transmises de manière sécurisée via Stripe.",
  card_number: "Numéro de carte",
  date_of_expiry: "Date d’expiration",
  ccv: "CCV",
  card_stored_correctly: "Les données ont été enregistrées.",
  enter_card_data_error: "Saisissez des données de carte valides.",
  plans: "Plans",
  activate_plan: "Activer le plan",
  current_plan: "Plan actuel",
  plan_valid_till: "valable jusqu’au",
  plans_headline: "Des tarifs flexibles adaptés à votre entreprise",
  plans_headline_2: "Simplifiez vos réservations et développez votre entreprise grâce à des solutions modernes !",
  monthly_payment: "Paiement mensuel",
  annual_payment: "Paiement annuel",
  for_free_forever: "gratuit à vie",
  monthly_no_vat: "par mois",
  yearly_no_vat: "par an",
  once_no_vat: "paiement unique",
  currently_used: "Vous utilisez actuellement",
  cancel_plan_generic_title: "Avant de prendre votre décision, n’oubliez pas que nous sommes toujours là pour vous ! 💬",
  cancel_plan_generic_info: "Discutez avec nous sur le chat pour trouver la solution la plus avantageuse pour vous 🤝 ou réservez une consultation en ligne gratuite, pendant laquelle nous répondrons à toutes vos questions.",
  cancel_plan: "Oui, je veux annuler et supprimer toutes mes données",
  cancel_plan_1: "Mes clients et moi perdrons l’accès au système de réservation. Toutes les données dans Calendesk, y compris les informations sur les clients, les réservations et les paiements, <strong>seront définitivement supprimées à la fin de l’abonnement</strong>.",
  cancel_plan_2: "Annuler l’abonnement",
  cancel_and_keep_data_button_title: "Annuler mais conserver mes données",
  cancel_subscription_title: "Voulez-vous vraiment annuler votre abonnement ? 😔",
  cancel_subscription_title_2: "Vous utilisez actuellement une période d’essai gratuite. Votre abonnement expirera automatiquement si vous ne finalisez pas l’achat.",
  cancel_subscription_subtitle_2: "Oui, je veux annuler, mais je souhaite conserver mes données",
  cancel_subscription_subtitle_3: "Vous ne pouvez pas annuler le plan pendant la période d’essai.",
  cancel_subscription_text: "Votre abonnement prendra fin le",
  cancel_subscription_text_2: "Toutes les fonctionnalités payantes resteront disponibles jusqu’à la fin de la période d’abonnement.",
  cancel_subscription_text_3: "Mes clients et moi perdrons l’accès au système de réservation, mais toutes les données dans Calendesk, y compris les informations sur les clients, les réservations et les paiements, <strong>seront conservées en toute sécurité après la fin de l’abonnement</strong>.",
  cancel_subscription_text_4: "Si vous avez une activité saisonnière ou souhaitez simplement mettre votre plan en pause pendant quelque temps, ne perdez pas vos données. Conservez-les en toute sécurité <strong>pour seulement @{price}/mois</strong>.",
  plans_advantage_1: "Nombre illimité d’employés",
  plans_advantage_2: "Panneau d’administration",
  plans_advantage_3: "Système de réservation et calendrier",
  plans_advantage_4: "Nombre illimité de clients",
  plans_advantage_5: "Historique des visites",
  plans_advantage_6: "Ressources liées aux réservations",
  plans_advantage_7: "Planning de travail",
  plans_advantage_8: "Paiements en ligne lors de la réservation",
  plans_advantage_9: "Notifications par e-mail",
  plans_advantage_10: "Pack SMS de démarrage : 50 messages",
  plans_advantage_11: "Pack SMS : 100 messages par mois",
  plans_advantage_12: "Pack SMS : 200 messages par mois",
  plans_advantage_13: "Assistance technique",
  plans_advantage_14: "Site web (sous-domaine Calendesk)",
  plans_advantage_15: "Application mobile pour les employés",
  plans_advantage_16: "Application mobile pour les clients",
  plans_advantage_17: "Application mobile indépendante pour les clients",
  plans_advantage_18: "Gestionnaire de compte dédié",
  plans_advantage_19: "Politique de confidentialité et conditions générales",
  plans_advantage_20: "Site web (votre propre domaine)",
  plans_advantage_21: "Certificat SSL pour le site web",
  plans_advantage_22: "1 employé",
  plans_advantage_23: "Jusqu’à 5 employés",
  plans_advantage_24: "Jusqu’à 250 clients",
  order_plan_summary_title: "Récapitulatif de la commande",
  monthly_subscription: "Abonnement mensuel",
  yearly_subscription: "Abonnement annuel",
  plan: "Plan",
  summary_payment: "Paiement",
  summary: "Total",
  promo_code: "Code de réduction",
  promo_code_is_invalid: "Le code de réduction a expiré ou est incorrect",
  promo_code_is_valid: "Le code de réduction a été appliqué à la commande",
  continue: "Continuer",
  continue_and_pay: "Continuer et payer",
  payment_method_deleted_successfully: "Le mode de paiement a été supprimé.",
  payment_method_delete_failed: "Le mode de paiement n’a pas été supprimé, veuillez réessayer.",
  subscription_set_successfully: "Votre abonnement a été configuré.",
  subscription_cancelled_successfully: "Votre abonnement a été annulé.",
  payment_method: "Mode de paiement",
  add_payment_method: "Ajouter un mode de paiement",
  change_payment_method: "Changer de mode de paiement",
  delete_payment_method: "Supprimer",
  my_invoices: "Mes factures",
  payment_history: "Historique des paiements",
  download_pdf: "Télécharger le PDF",
  invoice_data_updated_successfully: "Les données de facturation ont été mises à jour",
  invoice_data_update_failed: "Les données de facturation n’ont pas été mises à jour, veuillez réessayer.",
  tenant: "Entreprise",
  created: "Confirmation",
  prepayment: "Prépaiement",
  deleted: "Suppression",
  updated: "Modification",
  reminder: "Rappel",
  invoice_number: "Numéro de facture",
  invoice_issued_at: "Date d’émission",
  invoice_total: "Montant",
  invoice_vat: "TVA",
  invoice_description: "Description",
  buy_package_success: "Merci pour votre achat. L’activation peut prendre quelques secondes.",
  buy_package_failed: "Un problème est survenu lors de l’achat. Vérifiez que votre carte fonctionne et accepte les paiements.",
  buy_package_confirmation_button: "Acheter le pack",
  buy_package_confirmation_question: "Voulez-vous vraiment acheter ce pack ? Votre carte sera débitée.",
  incorrect_time: "Heure non valide",
  web_editor_color_1_label: "Couleur du bouton de validation",
  web_editor_color_2_label: "Filtre",
  web_editor_color_3_label: "Couleur du bouton d’annulation",
  web_editor_color_4_label: "Couleur de l’animation de chargement",
  web_editor_color_5_label: "Couleur de fond",
  web_editor_color_6_label: "Couleur du texte",
  web_editor_color_7_label: "Couleur de texte plus claire",
  web_editor_color_8_label: "Couleur de fond",
  web_editor_color_9_label: "Couleur des liens",
  web_editor_color_10_label: "Couleur des accents",
  web_editor_color_11_label: "Couleur de fond",
  web_editor_color_12_label: "Couleur de fond",
  web_editor_color_13_label: "Couleur du curseur",
  web_editor_color_14_label: "Couleur de fond",
  web_editor_color_15_label: "Couleur du texte",
  web_editor_color_16_label: "Couleur de fond",
  web_editor_color_17_label: "Couleur des icônes",
  web_editor_color_18_label: "Couleur des liens",
  contact_data_info: "Les coordonnées aideront vos clients à trouver votre entreprise et nous permettront d’envoyer certains messages. L’adresse e-mail fournie sera également définie comme adresse de réponse (« Reply-To ») dans les messages envoyés.",
  service_info_7: "Si vous activez l’option de prépaiement, vos clients devront payer avant que la réservation soit acceptée. En attendant, nous bloquerons le créneau dans le calendrier pour laisser à vos clients le temps de finaliser leur paiement. Les réservations non payées peuvent être supprimées après un certain temps afin de libérer votre calendrier. Consultez l’option ci-dessous.",
  awaiting_booking_payment_time: "Le paiement d’une réservation ponctuelle doit être effectué sous",
  payment_deadline_before_start: "Le paiement de chaque réservation récurrente doit être effectué au plus tard",
  service_description: "Une brève description du service sera affichée lors du choix du service.",
  company_data_saved: "Les données de votre entreprise ont été enregistrées",
  company_data_failed: "Une erreur est survenue. Les données de votre entreprise n’ont pas été enregistrées, veuillez réessayer.",
  closed: "Fermé",
  not_working: "Ne travaille pas",
  generate_regulations: "Générer",
  generate_regulations_success: "Les conditions générales et la politique de confidentialité ont été générées",
  generate_regulations_fail: "Un problème est survenu lors de la génération des conditions générales et de la politique de confidentialité, veuillez réessayer.",
  generate_regulations_info: "Générez des conditions générales et une politique de confidentialité utilisables sur votre site web Calendesk. Ces documents sont conçus pour les entreprises qui gèrent des réservations en ligne et traitent des paiements. Saisissez toutes les données de votre entreprise, puis cliquez sur « Générer ». Ajoutez les documents à votre site web à l’aide du créateur de site Calendesk, en sélectionnant les sections de la catégorie « Autres ». N’oubliez pas que les documents générés ne sont que des exemples : faites valider la version finale par un avocat. Calendesk n’est pas responsable du contenu de vos documents.",
  regulations_and_terms_title: "Générateur de documents",
  full_company_name: "Nom complet de votre entreprise",
  full_company_name_example: "p. ex. Pro&More SARL",
  full_company_address: "Adresse du siège social de votre entreprise",
  full_company_address_example: "p. ex. 1 rue de la Paix, 75002 Paris",
  regulations_data_services_1_label: "Pour quels services créez-vous les conditions générales ?",
  regulations_data_services_1_example: "p. ex. juridiques, psychologiques, cosmétiques",
  regulations_data_services_2_label: "Quels services proposez-vous ?",
  regulations_data_services_2_example: "p. ex. juridiques, psychologiques, cosmétiques",
  regulations_data_company_url_label: "Adresse URL du site web ou du calendrier",
  regulations_data_company_email_label: "Adresse e-mail de contact de l’entreprise",
  regulations_data_company_email_example: "p. ex. contact@monsite.fr",
  regulations_data_company_phone_label: "Téléphone de contact de l’entreprise",
  regulations_data_company_phone_example: "p. ex. +33612345678",
  regulations_data_date_label: "Les conditions générales s’appliquent à compter du",
  example_short: "p. ex.",
  privacy_policy_description_too_long: "Le texte de la politique de confidentialité est trop long (200 000 caractères).",
  regulations_description_too_long: "Le texte des conditions générales est trop long (200 000 caractères).",
  copy_data: "Copier les données",
  no_employees_info: "Vous n’avez pas encore d’employés, cliquez ci-dessous pour ajouter le premier.",
  no_users_info: "Vous n’avez pas encore de clients, cliquez ci-dessous pour ajouter le premier.",
  no_bookings_info: "Vous n’avez pas encore de réservations, cliquez ci-dessous pour ajouter la première.",
  no_services_info: "Vous n’avez pas encore de services, cliquez ci-dessous pour ajouter le premier.",
  no_categories_info: "Vous n’avez pas encore de catégories, cliquez ci-dessous pour ajouter la première.",
  no_newsletter_info: "Vous n’avez pas encore d’adresses e-mail dans la newsletter, cliquez ci-dessous pour ajouter la première.",
  employee_position: "Poste",
  employee_position_example: "p. ex. Responsable",
  employee_note_description: "Mettez ici votre employé en valeur : ces informations seront affichées sur le site web.",
  employee_permission_info: "Vous pouvez accorder des autorisations à votre employé et lui permettre de se connecter au système.",
  employee_permission_employee: "Employé (de confiance)",
  employee_permission_employee_basic: "Employé (accès restreint)",
  employee_permission_manager: "Manager",
  employee_permission_admin: "Administrateur",
  employee_permission_employee_info: "Les employés avec ce rôle ont un contrôle total sur leur calendrier et celui des autres employés. Ils peuvent déplacer des réservations entre employés. Ils ont accès aux comptes, réservations et paiements de tous les clients. Ils n’ont pas accès aux comptes des autres employés. Ils ne peuvent pas modifier les sites web ni changer les paramètres principaux du système.",
  employee_permission_employee_basic_info: "Les employés avec ce rôle ne voient que leur propre calendrier de réservations. Ils peuvent afficher, ajouter, modifier et supprimer des réservations uniquement sur leur compte. Ils peuvent rechercher des clients lors de l’ajout d’une réservation et voir leurs informations de base. Ils ne peuvent pas supprimer ni modifier les données des clients. Ils n’ont pas accès aux données des autres employés ni à leurs réservations.",
  employee_permission_manager_info: "Les comptes avec ce rôle ont les mêmes autorisations que les employés de confiance. Ils peuvent en plus gérer les comptes des autres employés, les services, les catégories et les sites web. Ils ne peuvent pas gérer les packs Calendesk et n’ont pas accès aux intégrations globales (p. ex. le système de paiement Stripe).",
  employee_permission_admin_info: "Les comptes administrateurs ont un accès complet à toutes les fonctions du panneau Calendesk.",
  choose_role: "Sélectionnez un rôle",
  employee_app_info: "Vos employés peuvent consulter le calendrier et les clients dans une application mobile dédiée, disponible sur iOS et Android. Cochez la case ci-dessous si vous souhaitez que nous envoyions un e-mail avec un lien de téléchargement de l’application.",
  employee_public_checkbox: "Cet employé est visible par les clients et accepte les réservations via le calendrier en ligne",
  employee_public_info: "Vous pouvez renseigner des informations supplémentaires (facultatives) sur l’employé. Ces données pourront ensuite être utilisées dans des sections spéciales, p. ex. sur le site web.",
  employee_working_hours: "Planning de disponibilité",
  employee_working_hours_info: "Le planning de disponibilité sélectionné sera utilisé pour les services qui reposent sur la disponibilité des employés.",
  color_in_calendar: "Couleur des événements dans le calendrier",
  delete_success: "Suppression effectuée.",
  update_success: "Vos modifications ont été enregistrées.",
  web_editor_color_19_label: "Couleur du texte",
  skip: "Passer",
  configuration: "Configuration",
  start_configuration: "C’est parti",
  fill: "Compléter",
  filled: "Terminé",
  create: "Créer",
  enable: "Activer",
  disable: "Désactiver",
  mobile_home_form_go_to_login_label: "Aller à la connexion",
  accept_terms_and_conditions_1: "En m’inscrivant, j’accepte les",
  accept_terms_and_conditions_2: "conditions d’utilisation",
  accept_terms_and_conditions_3: "et je confirme avoir lu la",
  accept_terms_and_conditions_4: "déclaration de confidentialité.",
  change_currency: "Changer la devise",
  change_currency_info: "La devise sera modifiée pour tous les services.",
  web_editor_color_20_label: "Couleur du slogan",
  copy: "Copier",
  copied_to_clipboard: "Copié dans le presse-papiers",
  stripe: "Stripe",
  stripe_description: "Acceptez les paiements de vos clients en temps réel grâce à Stripe, un opérateur de paiement avancé.",
  go_to_stripe: "Accéder à Stripe",
  stripe_info_step_1: "Cliquez sur « Créer un compte Stripe » pour accéder à Stripe et créer un compte. Une fois l’opération terminée, votre compte de paiement sera connecté à Calendesk. Calendesk n’aura pas accès à votre compte. Stripe est un opérateur de paiement indépendant. Connecter votre compte Stripe à Calendesk nous permettra de créer des paiements en votre nom, sur votre site web.",
  stripe_info_step_2: "Accédez à Stripe pour terminer la création de votre compte.",
  stripe_info_step_3: "Votre compte Stripe a été créé. Stripe vérifie maintenant vos informations.",
  stripe_info_step_4: "Votre compte Stripe est connecté. Vous pouvez accepter les paiements de vos clients. Pensez à cocher l’option « Prépaiement » pour les services qui exigent un prépaiement.",
  stripe_title_step_1: "Créer un compte Stripe",
  stripe_title_step_2: "Création du compte en cours",
  stripe_title_step_3: "Vérification du compte",
  stripe_title_step_4: "Compte connecté",
  allow_online_payments: "Paiement",
  allow_online_payment_2: "Activer les paiements en ligne pour ce service.",
  payment_required: "Prépaiement",
  payment_required_1: "Exiger un prépaiement",
  payment_required_2: "Exiger un prépaiement après la création d’une réservation ponctuelle.",
  payment_required_3: "après sa création.",
  payment_required_4: "Exiger un prépaiement pour les réservations récurrentes, avant le début de chaque réservation du cycle.",
  payment_required_5: "avant le début de la réservation.",
  payment_required_6: "Un rappel de paiement sera envoyé",
  payment_required_7: "avant le début de chaque réservation du cycle.",
  service_payments: "Paramètres de paiement",
  paid_online: "Paiement",
  paid: "Payé",
  not_paid: "Non payée",
  navbar_element_form_home_label: "Page d’accueil",
  user_payments: "Paiements",
  past_due_subscription_title: "Votre compte a été temporairement bloqué 😵",
  past_due_subscription_subtitle_1: "Nous sommes au regret de vous informer que votre compte Calendesk a été temporairement bloqué en raison d’impayés. Nous avons tenté de débiter votre carte à plusieurs reprises, sans succès. Nous vous invitons à vérifier votre carte, puis à réessayer le paiement.",
  past_due_subscription_subtitle_2: "Si vous souhaitez changer de carte, vous pouvez le faire ci-dessous. Une fois le paiement effectué, votre compte sera automatiquement débloqué. Pour toute question, contactez-nous par chat : nous vous aiderons volontiers à résoudre le problème de paiement.",
  past_due_subscription_subtitle_3: "Nous sommes au regret de vous informer que le compte Calendesk a été temporairement bloqué en raison d’impayés. Veuillez contacter au plus vite l’administrateur du compte ou la personne responsable des paiements.",
  retry_past_due_invoice_title: "Régler l’impayé",
  past_due_subscription_title_2: "Un paiement est en retard sur votre compte",
  past_due_subscription_subtitle_4: "Veuillez effectuer le paiement pour éviter le blocage automatique de votre compte.",
  past_due_subscription_subtitle_5: "Tant que des paiements restent impayés sur votre compte, il n’est pas possible de modifier ou d’annuler vos abonnements.",
  past_due_subscription_subtitle_6: "Si vous souhaitez changer de carte, vous pouvez le faire ci-dessous. Pour toute question, contactez-nous par chat : nous vous aiderons volontiers à résoudre le problème de paiement.",
  select_plan: "Choisissez un plan",
  subscription_will_not_renew_info: "Votre plan ne sera pas renouvelé automatiquement",
  no_email_for_password_reset_info: "Vous ne pouvez pas définir de mot de passe si l’utilisateur sélectionné n’a pas d’adresse e-mail renseignée.",
};
